import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';

import ReduxDialog from '../ReduxDialog';
import { hideDialog } from '../../../actions/dialogs';

import styles from './styles';

class AlertDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    titleStyle: PropTypes.object.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  render() {
    const buttons = [
      <FlatButton
        label="OK"
        onClick={() => this.props.hideDialog('alert')}
      />,
    ];

    const { title, message } = this.props;
    return (
      <ReduxDialog
        name="alert"
        title={title}
        actions={buttons}
        titleStyle={this.props.titleStyle}
        bodyStyle={styles.body}
      >
        <div>{message}</div>
      </ReduxDialog>
    );
  }
}

function getTitleStyle(type) {
  switch (type) {
    case 'severe':
      return {
        backgroundColor: 'red',
        color: 'white',
      }
    case 'warning':
      return {
        backgroundColor: 'orange',
        color: 'white',
      }
    default:
      return null;
  }
}

function mapStateToProps(state) {
  const alertDialog = state.get('dialogs').get('dialogs').get('alert');
  if (alertDialog) {
    const context = alertDialog.get('context');
    if (context) {
      return {
        title: context.get('title'),
        message: context.get('message'),
        titleStyle: context.get('titleStyle') || getTitleStyle(context.get('type')),
      };
    }
  }

  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/Common/AlertDialog/index.js